import React from 'react';

const NavbarHelp = ({showContact}) => {
  return (
    <div className={showContact ? 'help-visible' : ''}>
      {showContact ? (
        <div>
          <div className="help-text-container">
            <p className="help-normal-text">Problème technique ?</p>
            <p className="help-normal-text">Besoin d&apos;infos commerciales ?</p>
          </div>
          <p className="help-small-text">Contactez notre équipe :</p>
          <div>
            <div className="help-contact-group">
              <i className="fas fa-phone-alt" />
              <p className="help-bold-text">00 00 00 00 00</p>
            </div>
            <div className="help-contact-group">
              <i className="far fa-envelope" />
              <p className="help-bold-text">support@sublissi.me</p>
            </div>
          </div>
        </div>
      ) : (
        <p>Besoin d&apos;aide ?</p>
      )}
    </div>
  );
};

export default NavbarHelp;
